import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Modal } from '@resy/ui-kitchen';
import AuthContainer from './WrappedAuthContainer';

const AuthContainerModal = ({
  $location,
  $rootScope,
  $route,
  Analytics,
  AutomationMode,
  closeModal,
  firstStep,
  successCallback,
  callingCode,
  ResyAmexConfig,
}) => {
  const [contentLabel, setContentLabel] = useState('');

  return (
    <Modal
      isOpen
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      styles={{ content: { padding: '0px' } }}
      contentLabel={contentLabel}
    >
      <AuthContainer
        $location={$location}
        $rootScope={$rootScope}
        $route={$route}
        Analytics={Analytics}
        AutomationMode={AutomationMode}
        callingCode={callingCode}
        close={closeModal}
        firstStep={firstStep}
        successCallback={successCallback}
        ResyAmexConfig={ResyAmexConfig}
        setContentLabel={setContentLabel}
      />
    </Modal>
  );
};

AuthContainerModal.propTypes = {
  $location: PropTypes.shape({
    search: PropTypes.func.isRequired,
  }).isRequired,
  $route: PropTypes.shape({
    reload: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    $on: PropTypes.func.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape(
    { event: PropTypes.func }
  ).isRequired,
  AutomationMode: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  firstStep: PropTypes.string,
  successCallback: PropTypes.func,
  callingCode: PropTypes.string,
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
  }).isRequired,
};

AuthContainerModal.defaultProps = {
  firstStep: undefined,
  callingCode: '1',
  successCallback: () => {},
};

export default AuthContainerModal;
